<form [formGroup]="lobbyEditForm">
  <kendo-dialog id="serviceDialogModel" title="{{'_General_Button_Edit_Text_' | translate }}" *ngIf="dialogOpened" (close)="close()">
    <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
    <div class="psPanel">
      <div class="ps-list">
        <div class="row">
          <!-- Visitor Information -->
          <div class="col-md-6">
            <!-- Account Number -->
            <div class="input" *ngIf="lobbyConfiguration.EnableAccountNumber">
              <label for="accountNumber">{{'_Account_Number_Field_Text_' | translate}}</label>
              <input id="accountNumber" class="form-control" formControlName="accountNumber" type="text" maxlength="50" app-filter
                pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,●])*$" (keypress)="keypress($event)"
                (keyup)="onAccountNumberKeyUp($event)" input-field-on-past-filter (focusout)="accountNumberFocusOut()"
                (input)="onAccountNumberChange($event)" />
              <div class="cc-validation">
                <div id="accountNumberErrorMessage" *ngIf="lobbyEditForm.get('accountNumber')?.hasError('pattern')">
                  {{'_General_User_Invalid_Text_' | translate }} {{'_Account_Number_Field_Text_' | translate }}
                </div>
              </div>
            </div>
            <!-- First Name & Last Name -->
            <div class="row">
              <div class="col-md-6 input">
                <label for="first-name">{{'_General_User_First_Name_Text_' | translate }}
                  <span tabindex="-1" class="required-field">*</span>
                </label>
                <input app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$"
                  id="firstName" class="form-control" formControlName="firstName" type="text" maxlength="50" (keypress)="keypress($event)"/>
                <div class="cc-validation">
                  <div id="firstNameRequiredErrorMessage" *ngIf="lobbyEditForm.get('firstName')?.hasError('required') ||lobbyEditForm.get('firstName')?.hasError('noEmptyValue')">
                   {{'_General_User_First_Name_Required_Text_' | translate }}
                  </div>
                </div>
                <div class="cc-validation">
                  <div id="firstNameValidationErrorMessage" *ngIf="lobbyEditForm.get('firstName')?.hasError('pattern')">
                   {{'_General_User_First_Name_Invalid_Text_' | translate }}
                  </div>
                </div>
              </div>

              <div class="col-md-6 input">
                <label for="lastName">{{'_General_User_Last_Name_Text_' | translate }}
                  <span tabindex="-1" class="required-field">*</span>
                </label>
                <input app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$"
                  id="lastName" class="form-control" formControlName="lastName" type="text" maxlength="50"   (keypress)="keypress($event)" />
                <div class="cc-validation">
                  <div id="lastNameRequiredErrorMessage" 
                  *ngIf="lobbyEditForm.get('lastName')?.hasError('required') || lobbyEditForm.get('lastName')?.hasError('noEmptyValue')">
                    {{'_General_User_Last_Name_Required_Text_' | translate }}
                  </div>
                </div>
                <div class="cc-validation">
                  <div id="lastNameValidationErrorMessage" *ngIf="lobbyEditForm.get('lastName')?.hasError('pattern')">
                    {{'_General_User_Last_Name_Invalid_Text_' | translate }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Phone Number & Receive Text Messages -->
            <div class="row" *ngIf="lobbyConfiguration.EnablePhoneNumber">
              <div class="col-md-6 input">
                <label for="phoneNumber">{{'_General_User_Phone_Optional_Text_' | translate }}</label>
                <input id="phoneNumber" class="form-control" formControlName="phoneNumber" type="text"
                  pattern="^[\d\(\) \-]*$" maxlength="14" (keyup)="EnableReceiveTextMessageCheckBox()" (blur)="blur()"
                  app-filter />
                <div class="cc-validation">
                  <div id="phoneNumberValidationErrorMessage"
                    *ngIf="lobbyEditForm.get('phoneNumber')?.hasError('pattern')">
                     {{'_General_User_Phone_Invalid_Text_' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 checkbox receive-text"
                *ngIf="lobbyConfiguration && lobbyConfiguration.EnablePhoneNumber &&  lobbyConfiguration.EnableTextMessageNotification ">
                <label>
                  <input class="cc-filter-checkbox" id="receivetextmessages" type="checkbox" kendoCheckBox formControlName="recieveTextUpdate" />
                  {{'_General_Receive_Text_Messages_Text_' | translate }}
                </label>
                <span>({{'_Shared_ModalPopUp_Lobby_Edit_Data_Rates_Text_' | translate }})</span>
              </div>
            </div>

            <!-- Email Address & Date of Birth -->
            <div class="row">
              <div class="col-md-6 input" *ngIf="lobbyConfiguration.EnableEmailAddress">
                <label for="email">{{'_General_User_Email_Optional_Text_' | translate }}</label>
                <input input-field-on-past-filter
                pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$" id="email"
                  class="form-control" formControlName="email" type="email" maxlength="256" />
                <div class="cc-validation">
                  <div id="invalidEmailErrorMessage" *ngIf="lobbyEditForm.get('email')?.hasError('invalidEmail')">
                    {{'_General_User_Email_Invalid_Text_' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 input" *ngIf="lobbyConfiguration.EnableDateOfBirth">
                <label for="dob">{{'_General_User_DOB_Optional_Text_' | translate }}</label>
                <input id="dob" class="form-control" formControlName="dateOfBirth" type="date" min="1900-01-01"
                  [max]="dateSelectionMaxLimit" />
              </div>
            </div>

            <!-- Person Requested & Spanish Speaker Preferred -->
            <div class="row">
              <div class="col-md-6 dropdown">
                <label for="staffMember">{{'_General_Report_Staff_Requested_Text_' | translate }}
                  <span *ngIf="lobbyConfiguration && lobbyConfiguration.MakeStaffMemberSelectionMandatory" tabindex="-1"
                    class="required-field">*</span>
                </label>
                
                <select class="cc-select-dropdown form-control" id="staffMember" placeholder="_General_Select_Text_ | translate "
                  formControlName="personRequested" (change)="changeRequestedUser($event)" >
                  <option [ngValue]="-1">
                    {{'_General_Select_Text_' | translate }}
                  </option>
                  <option *ngFor="let staffMember of staffMembers" [ngValue]="staffMember.userId">
                    {{ staffMember.firstName }} {{ staffMember.lastName }}
                  </option>
                </select>
                <div class="cc-validation">
                  <div id="staffRequiredErrorMessage" *ngIf="staffMemberRequiredMessage">
                    {{ staffMemberRequiredMessage }}
                  </div>
                </div>
              </div>
              <div class="col-md-6 checkbox spanish-speaker">
                <label>
                  <input class="cc-filter-checkbox" id="spanishSpeaker" type="checkbox" kendoCheckBox
                    formControlName="spanishSpeaker" (click)="spanishSpeakerCheckBoxClick($event)"
                    [checked]="spanishSpeakerPrefferChecked$ | async" />
                    {{'_General_Notes_ES_Speaker_Text_' | translate }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-6 requests-notes d-flex">
            <!-- Requests -->
            <div class="requests">
              <div class="row">
                <div class="col-md-12">
                  <h6 class="sub-heading">{{'_General_Reasons_To_Visit_Text_' | translate }}</h6>
                </div>
                <div class="
                    col-md-12
                    reason-for-visit-actions
                    lobby-record-edit-reasons
                  ">
                  <ng-multiselect-dropdown name="services" formControlName="requests" id="requestedServices"
                    [placeholder]="'_General_Select_Text_' | translate" [settings]="dropdownSettings" [data]="allServices">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
            <!-- Custom Notes & Notes -->
            <div class="row mt-4">
              <div class="col-md-6" *ngIf="lobbyConfiguration.EnableCustomField">
                <label class="notes-label" for="notes">{{'_Custom_Field_Text_' | translate }}</label>
                <div class="cc-textarea-container">
                  <div class="cc-textarea">
                    <textarea app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$"
                      formControlName="customFieldValues" maxlength="250" id="customNotes" class="form-control" rows="3"
                      input-field-on-past-filter></textarea>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <label class="notes-label" for="notes">{{'_General_Notes_Info_Text_' | translate }}</label>
                <div class="cc-textarea-container">
                  <div class="cc-textarea">
                    <textarea app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$"
                      maxlength="500" id="notes" class="form-control" formControlName="notes" rows="3"
                      input-field-on-past-filter></textarea>
                    <div class="cc-validation">
                      <div id="invalidNoteErrorMessage" *ngIf="lobbyEditForm.get('notes')?.hasError('pattern')">
                        {{'_General_Notes_Invalid_Text_' | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <kendo-dialog-actions class="cc-btn-panel">
      <button id="cancelButton" class="btn btn-secondary" (click)="close()">{{'_General_Button_Cancel_Text_' | translate }}</button>
      <button class="btn btn-primary" id="saveButton"
        [disabled]="!this.lobbyEditForm.dirty || !this.lobbyEditForm.valid || staffMemberRequired"
        (click)="saveEditedlLobbyRecord(lobbyEditForm.value)">
        {{'_General_Button_Save_Text_' | translate }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
</form>
